import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaArrowCircleRight, FaWhatsapp, FaHeadset } from 'react-icons/fa';
import '../../styles/pages/_contact.scss';
import Icon from '../../components/Icons/Icon';

const API_URL = process.env.REACT_APP_API_URL;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateName = (value) => {
    return value.replace(/[^a-zA-ZçğıöşüÇĞIİÖŞÜ\s]/g, '').slice(0, 50);
  };

  const validateEmail = (value) => {
    return value.toLowerCase().slice(0, 50);
  };

  const validatePhone = (value) => {
    return value.replace(/[^0-9\s\-\(\)\+]/g, '').slice(0, 11);
  };

  const validateSubject = (value) => {
    return value.slice(0, 50);
  };

  const validateMessage = (value) => {
    return value.slice(0, 2000);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let validatedValue = value;

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }

    switch (name) {
      case 'name':
        validatedValue = validateName(value);
        break;
      case 'email':
        validatedValue = validateEmail(value);
        break;
      case 'phone':
        validatedValue = validatePhone(value);
        break;
      case 'subject':
        validatedValue = validateSubject(value);
        break;
      case 'message':
        validatedValue = validateMessage(value);
        break;
      default:
        break;
    }

    setFormData(prevState => ({
      ...prevState,
      [name]: validatedValue
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Ad Soyad alanı zorunludur.';
    } else if (formData.name.trim().length < 2) {
      newErrors.name = 'Ad Soyad en az 2 karakter olmalıdır.';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = 'E-posta alanı zorunludur.';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Geçerli bir e-posta adresi girin.';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Telefon numarası zorunludur.';
    } else if (formData.phone.replace(/[^0-9]/g, '').length < 10) {
      newErrors.phone = 'Geçerli bir telefon numarası girin.';
    }

    if (!formData.subject.trim()) {
      newErrors.subject = 'Konu alanı zorunludur.';
    } else if (formData.subject.trim().length < 5) {
      newErrors.subject = 'Konu en az 5 karakter olmalıdır.';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Mesaj alanı zorunludur.';
    } else if (formData.message.trim().length < 10) {
      newErrors.message = 'Mesaj en az 10 karakter olmalıdır.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    if (!validateForm()) {
      return;
    }

    try {
      setIsSubmitting(true);
      const res = await fetch(`${API_URL}/Contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: formData.name.trim(),
          email: formData.email.trim(),
          phone: formData.phone.trim(),
          subject: formData.subject.trim(),
          message: formData.message.trim()
        })
      });

      const raw = await res.text();
      let data = null;
      try { data = JSON.parse(raw); } catch {  }

      if (!res.ok) {
        const msg = data?.resultMessage || raw || `HTTP ${res.status}`;
        throw new Error(msg);
      }

      if (!data?.isSuccess) {
        throw new Error(data?.resultMessage || 'İşlem başarısız.');
      }

      alert('Mesajınız alındı. Teşekkürler.');
      
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      
    } catch (err) {
      alert('Gönderim sırasında hata oluştu: ' + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="container">
        <div className="contact-header">
          <h1>İletişim</h1>
          <p>Bizimle iletişime geçin</p>
        </div>

        <div className="contact-content">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-info">
                <div className="info-item">
                  <div className="info-icon">
                    <FaMapMarkerAlt size={24} />
                  </div>
                  <div className="info-content">
                    <h3>Adres</h3>
                    <p>Yenişehir Mah. Mareşal Çakmak Cad. No: 48 İskenderun/HATAY</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaPhone size={24} />
                  </div>
                  <div className="info-content">
                    <h3>Telefon</h3>
                    <p>0326 613 49 90</p>
                    <p>0326 613 49 91</p>
                    <p>0326 613 49 92</p>
                    <p>0326 613 49 93</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaEnvelope size={24} />
                  </div>
                  <div className="info-content">
                    <h3>E-posta</h3>
                    <p>bilgi@iskenderun.bel.tr</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaHeadset size={24} />
                  </div>
                  <div className="info-content">
                    <h3>İstek ve Talep Hattı</h3>
                    <p>444 19 39</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaWhatsapp size={24} />
                  </div>
                  <div className="info-content">
                    <h3>WhatsApp Hattı</h3>
                    <a href="https://wa.me/905305421939" target="_blank" rel="noopener noreferrer" className="whatsapp-link">
                      0530 542 19 39
                    </a>
                  </div>
                </div>

                <div className="map-container">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3203.469592789977!2d36.1665113763728!3d36.59099767946333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x152f593117d7023b%3A0xd4ca2318eac3fa53!2sT.C.%20%C4%B0skenderun%20Belediyesi!5e0!3m2!1str!2str!4v1741013165686!5m2!1str!2str"
                    width="100%"
                    height="300"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    title="İskenderun Belediyesi Harita"
                  ></iframe>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="contact-form">
                <h2>İletişim Formu</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      name="name"
                      placeholder="Adınız Soyadınız"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      maxLength={100}
                      className={errors.name ? 'error' : ''}
                    />
                    {errors.name && <small className="error-text">{errors.name}</small>}
                    <small className="char-count">{formData.name.length}/50 karakter</small>
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      placeholder="E-posta Adresiniz"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      maxLength={100}
                      className={errors.email ? 'error' : ''}
                    />
                    {errors.email && <small className="error-text">{errors.email}</small>}
                    <small className="char-count">{formData.email.length}/50 karakter</small>
                  </div>

                  <div className="form-group">
                    <input
                      type="tel"
                      name="phone"
                      placeholder="Telefon Numaranız"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      maxLength={15}
                      className={errors.phone ? 'error' : ''}
                    />
                    {errors.phone && <small className="error-text">{errors.phone}</small>}
                    <small className="char-count">{formData.phone.length}/11 karakter</small>
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      name="subject"
                      placeholder="Konu"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                      maxLength={200}
                      className={errors.subject ? 'error' : ''}
                    />
                    {errors.subject && <small className="error-text">{errors.subject}</small>}
                    <small className="char-count">{formData.subject.length}/50 karakter</small>
                  </div>

                  <div className="form-group">
                    <textarea
                      name="message"
                      placeholder="Mesajınız"
                      value={formData.message}
                      onChange={handleChange}
                      required
                      rows="5"
                      maxLength={2000}
                      className={errors.message ? 'error' : ''}
                    ></textarea>
                    {errors.message && <small className="error-text">{errors.message}</small>}
                    <small className="char-count">{formData.message.length}/2000 karakter</small>
                  </div>

                  <button
                    type="submit"
                    className="submit-button"
                    disabled={isSubmitting}
                    aria-busy={isSubmitting}
                    aria-live="polite"
                  >
                    {isSubmitting ? 'Gönderiliyor…' : 'Başvuruyu Gönder'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .error {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
        }
        
        .error-text {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 0.25rem;
          display: block;
        }
        
        .char-count {
          color: #6c757d;
          font-size: 0.75rem;
          display: block;
          margin-top: 0.25rem;
        }
        
        .form-group {
          position: relative;
          margin-bottom: 1rem;
        }
      `}</style>
    </div>
  );
};

export default Contact;